import Keen from 'keen-js'
import config from '../config'

// helpers

function getUsersToExclude (videoOrCampaign) {
  if (videoOrCampaign.hasOwnProperty('users_to_exclude') && videoOrCampaign.users_to_exclude !== null) {
    return videoOrCampaign.users_to_exclude
  }
  return []
}

// /helpers

var client = new Keen({
  projectId: config.keen.report.projectId,
  readKey: config.keen.report.readKey
})

export function createClient () {
  return client
}

export function createQueryCTA (analysisType, eventCollection, timeframe, campaign, video = null, target = null, interval = null, extrafilters = [], groupBy = []) {
  var viewer_id_property_name = 'client_viewer_id'
  if (eventCollection === 'url_expanded') {
    viewer_id_property_name = 'viewer_id'
  }
  var localExtraFilters = extrafilters.slice(0)
  if (campaign !== null && campaign.hasOwnProperty('data_state') && campaign.data_state !== undefined && campaign.data_state !== null && video === null) {
    localExtraFilters.push({
      operator: 'eq',
      property_name: 'data_state',
      property_value: campaign.data_state
    })
  }
  if (video !== null && video.hasOwnProperty('data_state') && video.data_state !== undefined && video.data_state !== null) {
    // Não adicionar data_state ao vídeo Fundos de Investimentos ITAU
    // Necessário pois não estava salvando data_state corretamente.
    // Autor: Rafael Uchoa. 30/07/2018
    if (video.id !== '5af0b56a8a2f1b000abe8795' && video.id !== '5a79fd8db87d0b000651d4fd') {
      localExtraFilters.push({
        operator: 'eq',
        property_name: 'data_state',
        property_value: video.data_state
      })
    }
  }
  if (video !== null) {
    let usersToExclude = getUsersToExclude(video)
    if (usersToExclude.length > 0) {
      usersToExclude.forEach(user => {
        localExtraFilters.push({
          operator: 'ne',
          property_name: 'client_viewer_id',
          property_value: user
        })
      })
    }
  }
  if (campaign !== null && video === null) {
    let usersToExclude = getUsersToExclude(campaign.videos[0])
    if (usersToExclude.length > 0) {
      usersToExclude.forEach(user => {
        localExtraFilters.push({
          operator: 'ne',
          property_name: viewer_id_property_name,
          property_value: user
        })
      })
    }
  }

  /* Filtrando Firefox do preview do SMS! */
  localExtraFilters.push({
    operator: "ne",
    property_name: "user_agent",
    property_value:
      "Mozilla/5.0 (X11; Ubuntu; Linux i686; rv:24.0) Gecko/20100101 Firefox/24.0"
  });

  let defaultOptions = {
    event_collection: eventCollection,
    filters: localExtraFilters,
    timeframe
  }
  if (target !== null) defaultOptions['target_property'] = target
  if (interval !== null) defaultOptions['interval'] = interval
  if (groupBy.length > 0) defaultOptions['group_by'] = groupBy
  return new Keen.Query(analysisType, defaultOptions)
}

export function createQuery (analysisType, eventCollection, timeframe, campaign, video = null, target = null, interval = null, extrafilters = [], groupBy = []) {
  var localExtraFilters = extrafilters.slice(0)
  var viewer_id_property_name = 'client_viewer_id'
  if (eventCollection === 'url_expanded') {
    viewer_id_property_name = 'viewer_id'
  }
  let filters = [
    {
      operator: 'ne',
      property_name: viewer_id_property_name,
      property_value: '11998648454'
    },
    {
      operator: 'ne',
      property_name: viewer_id_property_name,
      property_value: 'RAFAEL-2'
    },
    {
      operator: 'ne',
      property_name: viewer_id_property_name,
      property_value: '737029860'
    }
  ]
  // if (campaign !== null) {
  //   filters.push({
  //     operator: 'eq',
  //     property_name: 'campaign_id',
  //     property_value: campaign.id
  //   })
  // }
  if (campaign !== null && video === null) {
    let usersToExclude = getUsersToExclude(campaign.videos[0])
    if (usersToExclude.length > 0) {
      usersToExclude.forEach(user => {
        filters.push({
          operator: 'ne',
          property_name: viewer_id_property_name,
          property_value: user
        })
      })
    }
  }
  if (campaign !== null && campaign.hasOwnProperty('data_state') && campaign.data_state !== undefined && campaign.data_state !== null && video === null) {
    localExtraFilters.push({
      operator: 'eq',
      property_name: 'data_state',
      property_value: campaign.data_state
    })
  }
  if (video !== null && typeof video !== 'string') {
    let usersToExclude = getUsersToExclude(video)
    if (usersToExclude.length > 0) {
      usersToExclude.forEach(user => {
        filters.push({
          operator: 'ne',
          property_name: viewer_id_property_name,
          property_value: user
        })
      })
    }
    filters.push({
      operator: 'eq',
      property_name: 'video_id',
      property_value: video.id
    })
  } else if (typeof video === 'string') {
    filters.push({
      operator: 'eq',
      property_name: 'video_id',
      property_value: video
    })
  }
  if (video !== null && video.hasOwnProperty('data_state') && video.data_state !== undefined && video.data_state !== null) {
    // Não adicionar data_state ao vídeo Fundos de Investimentos ITAU
    // Necessário pois não estava salvando data_state corretamente.
    // Autor: Rafael Uchoa. 30/07/2018
    if (video.id !== '5af0b56a8a2f1b000abe8795' && video.id !== '5a79fd8db87d0b000651d4fd') {
      filters.push({
        operator: 'eq',
        property_name: 'data_state',
        property_value: video.data_state
      })
    }
  }

  /* Filtrando Firefox do preview do SMS! */
  localExtraFilters.push({
    operator: "ne",
    property_name: "user_agent",
    property_value:
      "Mozilla/5.0 (X11; Ubuntu; Linux i686; rv:24.0) Gecko/20100101 Firefox/24.0"
  });

  if (localExtraFilters.length > 0) {
    filters = [
      ...filters,
      ...localExtraFilters
    ]
  }
  let defaultOptions = {
    event_collection: eventCollection,
    filters,
    timeframe
  }
  if (target !== null) defaultOptions['target_property'] = target
  if (interval !== null) defaultOptions['interval'] = interval
  if (groupBy.length > 0) defaultOptions['group_by'] = groupBy
  return new Keen.Query(analysisType, defaultOptions)
}

export function createQueryGambi (analysisType, eventCollection, timeframe, campaign, video = null, target = null, interval = null, extrafilters = [], groupBy = []) {
  var viewer_id_property_name = 'client_viewer_id'
  if (eventCollection === 'url_expanded') {
    viewer_id_property_name = 'viewer_id'
  }
  let filters = [
    {
      operator: 'ne',
      property_name: viewer_id_property_name,
      property_value: '11998648454'
    },
    {
      operator: 'ne',
      property_name: viewer_id_property_name,
      property_value: 'RAFAEL-2'
    },
    {
      operator: 'ne',
      property_name: viewer_id_property_name,
      property_value: '737029860'
    }
  ]
  // if (campaign !== null) {
  //   filters.push({
  //     operator: 'eq',
  //     property_name: 'campaign_id',
  //     property_value: campaign.id
  //   })
  // }
  if (campaign !== null && campaign.hasOwnProperty('data_state') && campaign.data_state !== undefined && campaign.data_state !== null && video === null) {
    extrafilters.push({
      operator: 'eq',
      property_name: 'data_state',
      property_value: campaign.data_state
    })
  }
  if (campaign !== null && video === null) {
    let usersToExclude = getUsersToExclude(campaign.videos[0])
    if (usersToExclude.length > 0) {
      usersToExclude.forEach(user => {
        filters.push({
          operator: 'ne',
          property_name: viewer_id_property_name,
          property_value: user
        })
      })
    }
  }
  if (video !== null && typeof video !== 'string') {
    let usersToExclude = getUsersToExclude(video)
    if (usersToExclude.length > 0) {
      usersToExclude.forEach(user => {
        filters.push({
          operator: 'ne',
          property_name: viewer_id_property_name,
          property_value: user
        })
      })
    }
    filters.push({
      operator: 'eq',
      property_name: 'video_id',
      property_value: video.player_video_id
    })
  } else if (typeof video === 'string') {
    filters.push({
      operator: 'eq',
      property_name: 'video_id',
      property_value: video
    })
  }
  if (video !== null && video.hasOwnProperty('data_state') && video.data_state !== undefined && video.data_state !== null) {
    filters.push({
      operator: 'eq',
      property_name: 'data_state',
      property_value: video.data_state
    })
  }

  /* Filtrando Firefox do preview do SMS! */
  extrafilters.push({
    operator: "ne",
    property_name: "user_agent",
    property_value:
      "Mozilla/5.0 (X11; Ubuntu; Linux i686; rv:24.0) Gecko/20100101 Firefox/24.0"
  });

  if (extrafilters.length > 0) {
    filters = [
      ...filters,
      ...extrafilters
    ]
  }
  let defaultOptions = {
    event_collection: eventCollection,
    filters,
    timeframe
  }
  if (target !== null) defaultOptions['target_property'] = target
  if (interval !== null) defaultOptions['interval'] = interval
  if (groupBy.length > 0) defaultOptions['group_by'] = groupBy
  return new Keen.Query(analysisType, defaultOptions)
}

export function runQuery (query) {
  return new Promise((resolve, reject) => {
    client.run(query, (err, res) => {
      if (err) {
        reject(err)
      } else {
        resolve(res)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/KeenReport.js